import { vehicleBrandConstants } from '../constants/vehicleBrandConstants';

const createItem = (items, item) => {
  items.unshift(item);
  return items;
};
const updateItem = (items, item) => {
  const result = [];
  for (let i = 0; i < items.length; i++) {
    if (items[i].id !== item.id) {
      result.push(items[i]);
    } else {
      result.push(item);
    }
  }
  return result;
};

const initialState = {
  showDeleteError: false,
  showFormModal: false,
  currentItem: {},
  selectItems: [],
  meta: { per_page: 7, total: 0, current_page: 1 },
  items: [],
  exportMessage: '',
  filters: {},
  sort: {}
};

export const vehicleBrands = (state = initialState, action) => {
  switch (action.type) {
    // Get all
    case vehicleBrandConstants.GET_ALL_REQUEST:
      return {
        ...state,
        loading: true,
        fetched: false
      };
    case vehicleBrandConstants.GET_ALL_SUCCESS:
      return {
        ...state,
        loading: false,
        selectItems: action.vehicleBrands.data,
        fetched: true
      };
    case vehicleBrandConstants.GET_ALL_FAILURE:
      return {
        // error: action.error.toString()
        ...state,
        loading: false,
        error: 'Не удалось загрузить список!',
        fetched: true
      };

    // Get page
    case vehicleBrandConstants.GET_PAGE_REQUEST:
      return {
        ...state,
        loading: true,
        filters: action.filters,
        sort: action.sort,
      };
    case vehicleBrandConstants.GET_PAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.vehicleBrands.data,
        meta: action.vehicleBrands.meta
      };
    case vehicleBrandConstants.GET_PAGE_FAILURE:
      return {
        // error: action.error.toString()
        ...state,
        loading: false,
        error: 'Не удалось загрузить список!'
      };

    // Get item
    case vehicleBrandConstants.LOAD_REQUEST:
      return {
        ...state,
        loading: true
      };
    case vehicleBrandConstants.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        currentItem: action.vehicleBrand.data
      };
    case vehicleBrandConstants.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Не удалось загрузить элемент!'
      };

    // Create
    case vehicleBrandConstants.CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: createItem(state.items, action.vehicleBrand),
        meta: {
          ...state.meta,
          total: state.meta.total + 1
        },
        showFormModal: false
      };

    // Update
    case vehicleBrandConstants.UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: updateItem(state.items, action.vehicleBrand),
        showFormModal: false
      };

    // Delete
    case vehicleBrandConstants.DELETE_REQUEST:
      return {
        ...state,
        items: state.items.map(vehicleBrand =>
          vehicleBrand.id === action.id ? { ...vehicleBrand, deleting: true } : vehicleBrand
        )
      };
    case vehicleBrandConstants.DELETE_SUCCESS:
      // remove deleted HeaderMenu from state
      return {
        ...state,
        loading: false,
        items: state.items.filter(vehicleBrand => vehicleBrand.id !== action.id),
        meta: {
          ...state.meta,
          total: state.meta.total - 1
        }
      };
    case vehicleBrandConstants.DELETE_FAILURE:
      return {
        ...state,
        showDeleteError: true,
        loading: false,
        items: state.items.map(vehicleBrand => {
          if (vehicleBrand.id === action.id) {
            // make copy of HeaderMenu without 'deleting:true' property
            const { deleting, ...vehicleBrandCopy } = vehicleBrand;
            // return copy of HeaderMenu with 'deleteError:[error]' property
            return { ...vehicleBrandCopy, deleteError: action.error };
          }

          return vehicleBrand;
        })
      };

    // accept
    case vehicleBrandConstants.ACCEPT_REQUEST:
      return {
        ...state,
        items: state.items.map(vehicleBrand =>
          vehicleBrand.id === action.id ? { ...vehicleBrand, accepting: true } : vehicleBrand
        )
      };
    case vehicleBrandConstants.ACCEPT_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.map(vehicleBrand =>
          vehicleBrand.id === action.id ? { ...vehicleBrand, accepted: 1 } : vehicleBrand
        )
      };
    case vehicleBrandConstants.ACCEPT_FAILURE:
      return {
        ...state,
        loading: false,
        items: state.items.map(vehicleBrand => {
          if (vehicleBrand.id === action.id) {
            const { accepting, ...vehicleBrandCopy } = vehicleBrand;
            return { ...vehicleBrandCopy, accepteError: action.error };
          }

          return vehicleBrand;
        })
      };

    case vehicleBrandConstants.HIDE_REQUEST:
      return {
        ...state,
        items: state.items.map(vehicleBrand =>
          vehicleBrand.id === action.id ? { ...vehicleBrand, accepting: true } : vehicleBrand
        )
      };
    case vehicleBrandConstants.HIDE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.filter(vehicleBrand => vehicleBrand.id !== action.id)
      };
    case vehicleBrandConstants.HIDE_FAILURE:
      return {
        ...state,
        loading: false,
        items: state.items.map(vehicleBrand => {
          if (vehicleBrand.id === action.id) {
            const { accepting, ...vehicleBrandCopy } = vehicleBrand;
            return { ...vehicleBrandCopy, accepteError: action.error };
          }

          return vehicleBrand;
        })
      };

    // form modal
    case vehicleBrandConstants.FORM_MODAL_OPEN:
      return {
        ...state,
        showFormModal: true
      };
    case vehicleBrandConstants.FORM_MODAL_CLOSE:
      return {
        ...state,
        showFormModal: false
      };
    case vehicleBrandConstants.SET_CURRENT_ITEM:
      return {
        ...state,
        currentItem: action.item
      };
    case vehicleBrandConstants.CLOSE_ERROR_MODAL:
      return {
        ...state,
        showDeleteError: false
      };

    case vehicleBrandConstants.EXPORT_UPLOAD_REQUEST:
      return {
        ...state,
        loading: true,
        exportMessage: ''
      };
    case vehicleBrandConstants.EXPORT_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.vehicleBrands.data,
        meta: action.vehicleBrands.meta,
        exportMessage: 'Файл успешно загружен!'
      };

    default:
      return state;
  }
};
